<template>
  <div>
    <vs-card class="mt-6 mb-base">
    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="msg">

        <template slot="header">
          <div class="vx-col sm:w-1/2 w-full">
            <img :src="require('@/assets/images/icons/icon_folder_b.png')" style="position: absolute;margin-left: 20px;" />
            <h3 style="margin-left: 55px;">Staging Message</h3>
          </div>

        <!-- ITEMS PER PAGE -->

          <div class="vx-col sm:w-1/4 w-full flex justify-between">
<!--            <vs-button @click="activePrompt=true">Export</vs-button>-->
            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ msg.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : msg.length }} of {{ queriedItems }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>

      <template slot="thead">
        <vs-th sort-key="MESSAGEID">Message ID</vs-th>
        <vs-th sort-key="SOURCE">Source</vs-th>
        <vs-th sort-key="TARGET">Target</vs-th>
        <vs-th sort-key="MESSAGETYPE">Message Type</vs-th>
        <vs-th sort-key="ACTIONTYPE">Action Type</vs-th>
        <vs-th sort-key="STATUS">Status</vs-th>
        <vs-th sort-key="DOCUMENTNUM">Document Number</vs-th>
        <vs-th sort-key="ERRORMSG">Error Message</vs-th>
        <vs-th sort-key="CREATED">Created</vs-th>
        <vs-th sort-key="PROCESSED">Processed</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
<!--            <router-link :to="'/staging/message/'+tr.MESSAGEID">-->
              <p class="product-name font-medium text-center">{{ tr.MESSAGEID }}</p>
<!--            </router-link>-->
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ tr.SOURCE }}</p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ tr.TARGET }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.MESSAGETYPE }}</p>
          </vs-td>
          <vs-td>
            <p class="product-category">
              <vs-chip :color="textAction(tr.ACTIONTYPE).color">
                <vs-avatar icon-pack="feather" icon="icon-send" color />
                <span>{{ textAction(tr.ACTIONTYPE).text }}</span>
              </vs-chip>
            </p>
          </vs-td>
          <vs-td>
            <p class="product-category">
              <vs-chip :color="textStatus(tr.STATUS).color">
                <vs-avatar icon-pack="feather" icon="icon-send" color />
                <span>{{ textStatus(tr.STATUS).text }}</span>
              </vs-chip>
            </p>
          </vs-td>

          <vs-td>
            <p>{{ tr.DOCUMENTNUM || '-' }}</p>
          </vs-td>
          <vs-td>
            <p>{{ tr.ERRORMSG || '-' }}</p>
          </vs-td>

          <vs-td>
            <p>{{ tr.CREATED ? moment(tr.CREATED).format('DD MMM YYYY, HH:mm:ss A') : '-' }}</p>
          </vs-td>
          <vs-td>
            <p v-if="tr.PROCESSED">{{ moment(tr.PROCESSED).format('YYYY') > 2000 ? moment(tr.PROCESSED).format('DD MMM YYYY, HH:mm:ss A') : '-' }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            <!--            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    </vs-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      selected: [],
      msg: [],
      itemsPerPage: 25,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.msg.length
    }
  },
  created () {
  },
  mounted () {
    this.$vs.loading()
    this.isMounted = true
    this.fetchMessages()
  },
  methods: {
    fetchMessages () {
      this.$http.get('/api/staging/message')
        .then(items => {
          this.msg = items.data.msg
          this.$vs.loading.close()
        })
        .catch(e => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Failed to fetch data',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    addNewData () {
      this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      // this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    textAction (action) {
      if (action === 'N') return { text:'New', color:'success' }
      else if (action === 'M') return { text:'Modify', color:'warning' }
      else if (action === 'D') return { text:'Delete', color:'danger' }
      else return { text:action, color:'secondary' }
    },
    textStatus (status) {
      if (status === 'N') return { text:'New', color:'success' }
      else if (status === 'R') return { text:'Ready', color:'primary' }
      else if (status === 'P') return { text:'Process', color:'warning' }
      else if (status === 'E') return { text:'Error', color:'danger' }
      else return { text:status, color:'secondary' }
    },
    moment (time) {
      return moment(time)
    }
  }
}
</script>

<style>
.vs-card--content {
  padding: 0px;
}
.vs-table--search {
  padding-right: 20px !important;
}
</style>
